module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-5-42ac2508f1a16b471f589d747940914d.webp";